module.exports = __webpack_public_path__ + "img/7.b6e57095.png";